import { useTranslation } from 'react-i18next';
import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import './authInstitutions.css';
import img from '../../assets/img/EN_ILO_Organization_Horizontal_RGB_Blue.png'
import AuthContext from '../../context/Auth/AuthContext'

function AuthInstitutions() {

    const { t } = useTranslation('common');
    const { authorizedInstitutions, select_institution, baseUrlLogoInstitutions } = useContext(AuthContext);
    const history = useHistory();
    const [arr, setArr] = useState([])

    /**
     * This function is triggered when an user clicks a table´s row. 
     * Redirects with the selected institution information
     * */
    const selectedInstitution = (index) => {
        /**Selected institution id*/
        let selectedInsId = index;
        select_institution(selectedInsId);
        history.push('/');
    }

    useEffect(() => {
        if (authorizedInstitutions && authorizedInstitutions.length === 1) {
            select_institution(0);
            history.push('/');
        } else {
            setArr(authorizedInstitutions ? authorizedInstitutions : []);
        }
    }, [authorizedInstitutions, select_institution, history])



    const institutions = arr.map((item, i) => {
        return (
            <tr className="authIns_tr" key={i} onClick={() => { selectedInstitution(i) }}>
                <td className="authIns_td">
                    <img src={`${baseUrlLogoInstitutions}${item.catInstitutionLogoFilename}`} alt={item.catInstitutionCountryName} height="80" />
                </td>
                <td className="authIns_td">{item.catInstitutionName}</td>
                <td className="authIns_td">{item.catInstitutionCountryName}</td>
                <td className="authIns_td">{t(`authInstitutions.${item.catRoleCode}`)}</td>
            </tr>
        );
    });

    return arr.length > 0 && (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-2"></div>
                <div className="col-md-8 authIns_fixed_table">
                    <table className="table">
                        {/* <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">{t('authInstitutions.tableHeader')}</th>
                                <th scope="col">Country</th>
                                <th scope="col">Role</th>
                            </tr>
                        </thead> */}
                        <tbody>
                            {/**Rows render: see institutions variable*/}
                            {institutions}
                        </tbody>
                    </table>
                </div>
                <div className="col-md-2"></div>
            </div>
        </div>
    );

}

export default AuthInstitutions